import React, { useState } from "react";
import Zoom from "react-medium-image-zoom";
import { FullScreen, useFullScreenHandle } from "react-full-screen"; 
import "react-medium-image-zoom/dist/styles.css";
import "./ImageViewer.css";
import "../../styles/styles.css"
import { register } from 'swiper/element/bundle';

register();

const ImageViewer = ({ images }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const screen1 = useFullScreenHandle();

  return (
<>
    <swiper-container style={
        {
        "height":"75vh",
        "--swiper-navigation-color": "#fff", 
        "--swiper-pagination-color": "#fff"
        }
    } 
    navigation="true"
    pagination-clickable="true" 

    className="mySwiper">
     {
      images.map((image)=>(
      <swiper-slide>
        <FullScreen  handle={screen1} enabled={isFullscreen} onChange={setIsFullscreen} >
          <Zoom className="center">
            <img src={image} alt="" />
          </Zoom>
        </FullScreen>
      </swiper-slide>
      ))
    }
  </swiper-container>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>

  </>
  );
};
export default ImageViewer;

/*
 {
      images.map((image)=>(
      <swiper-slide>
        <FullScreen  handle={screen1} enabled={isFullscreen} onChange={setIsFullscreen} >
          <Zoom className="center">
            <img src={image} alt="" />
          </Zoom>
        </FullScreen>
      </swiper-slide>
      ))
    }
*/